import replacement from '@/api/wholesale/v2/replacement'
import moment from 'moment'

import { baseState, baseMutations } from '@/store/mixins'
import { split } from "lodash"

export const state = {
  ...baseState,
  dateRange: [moment().startOf('M').format('DD-MM-YYYY'), moment().endOf('M').format('DD-MM-YYYY')],
  locationId: [],
  formViewDatas: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DATE_RANGE(state, date) {
    state.dateRange = date
  },
  SET_LOCATION_ID(state, data) {
    state.locationId = data
  },
  CLEAR_SETUP(state) {
    state.products = []
  },
  SET_VIEW_MODELS(state, { data, index }) {
    if (!index) {
      state.formViewDatas = data;
    } else {
      split(index, ",").forEach(el => {
        state.formViewDatas[el] = data[el];
      });
    }
  },
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        branch_id: context.state.branch_id,
        location_id: context.state.locationId,
        filter: {
          search: context.state.search,
          date_between: _.join(context.state.dateRange, ',')
        }
      },
      attrubutes
    )
    return replacement.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return replacement.store(data)
  },
  update(context, { id, data }) {
    return replacement.update(id, data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await replacement.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  destroy(context, id) {
    return replacement.destroy(id)
  },
  previewPdf(context, id) {
    return replacement.previewPdf(id)
  },
  async getFormViewModel(context, { params, index }) {
    let response = await replacement.formViewModel({ params: params });
    context.commit("SET_VIEW_MODELS", {
      data: response.data,
      index: index
    });
    return Promise.resolve(response);
  }
}
